export default "__VITE_ASSET__VPmZDeaG__"